import React, { useState, forwardRef, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
	Box,
	Stack,
	Drawer,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	Typography,
	Button,
	IconButton,
	Tooltip,
	Slide,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	TextField,
	Snackbar,
	Alert, Link
} from "@mui/material";
import { Menu, Save, Print, Replay } from "@mui/icons-material";
import { generatePDF } from "../../utils";
import { changeView, saveCalculator, clearCalculators, sendEmail } from "../calculators/calculatorsSlice";
import { updateView } from "../channelMix/settingsSlice";
import { clearOutputs } from "../channelMix/outputsSlice";
import { Version } from "./Version";

const TransitionComponent = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export const Toolbar = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const calculators = useSelector(state => state.calculators.schema);
	const loadingStatus = useSelector(state => state.calculators.status);
	const view = useSelector(state => state.calculators.view);
	// const mixView = useSelector(state => state.channelMix.settings.view);
	const account = useSelector(state => state.calculators.account);
	const calc = useSelector(state => state[view]);
	const email = useSelector(state => state.calculators.email);
	const [open, setOpen] = useState(false);
	const [notification, setNotification] = useState(false);
	const [dialog, setDialog] = useState(false);
	const [error, setError] = useState(false);
	const [name, setName] = useState("");

	const onClose = () => {
		setOpen(false);
	};

	const onOpenDialog = () => {
		setName(new Date().toLocaleTimeString([], {year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit"}));
		setDialog(true);
	};

	const onCloseDialog = () => {
		setDialog(false);
	};

	const closeNotification = () => {
		setNotification(false);
	};

	const onChange = (e) => {
		setName(e.target.value);
	};

	const nav = (key) => {
		dispatch(clearCalculators());
		const { path } = calculators[key];
		const view = path.slice(1);
		navigate(path);
		dispatch(changeView(view));
		onClose();
		window.scrollTo(0, 0);
	};

	const save = () => {
		dispatch(saveCalculator({type: view, name, json: JSON.stringify({calc, account})}));
	};

	const print = () => {
		setTimeout(() => {
			generatePDF();
		}, 800);
	};

	// const resetMix = () => {
	// 	dispatch(updateView("input"));
	// 	dispatch(clearOutputs());
	// };

	useEffect(() => {
		loadingStatus !== "loading" && setDialog(false);
	}, [loadingStatus]);

	useEffect(() => {
		!!email.message && setNotification(true);
	}, [email]);

	return (
		<>
			<Box sx={{display: "flex", py: 1}}>
				<Stack spacing={2} direction="row" alignItems="center" sx={{flex: 1}}>
					<Tooltip title="Menu" placement="top" arrow>
						<IconButton color="primary" onClick={() => setOpen(true)}><Menu /></IconButton>
					</Tooltip>
					<Routes>
						{calculators.map(({path, label}, key) =>
							<Route
								key={`route_heading_${key}`}
								{...{path}}
								element={<Typography>{label}</Typography>}
							/>
						)}
					</Routes>
				</Stack>
				{view === "mortgage" && <Version/>}
				<Stack spacing={2} direction="row" justifyContent="flex-end" sx={{flex: 1}}>
					{view === "mortgage" &&
						<Tooltip title="Save" placement="top" arrow>
							<IconButton color="primary" onClick={onOpenDialog}><Save /></IconButton>
						</Tooltip>
					}
					{/*{(view === "channel-mix" && mixView === "output") &&*/}
					{/*	<Tooltip title="Restart" placement="top" arrow>*/}
					{/*		<IconButton color="primary" onClick={resetMix}><Replay /></IconButton>*/}
					{/*	</Tooltip>*/}
					{/*}*/}
					<Tooltip title="Print" placement="top" arrow>
						<IconButton color="primary" onClick={print}><Print /></IconButton>
					</Tooltip>
				</Stack>
			</Box>
			<Drawer anchor="left" {...{open, onClose}}>
				<List sx={{pt: 12}}>
					<ListItem onClick={() => navigate("/")}>
						<ListItemButton>
							<ListItemText primary="Home" />
						</ListItemButton>
					</ListItem>
					{calculators.map(({label}, key) =>
						<ListItem onClick={() => nav(key)} key={`calc_item_${key}`}>
							<ListItemButton>
								<ListItemText primary={label} />
							</ListItemButton>
						</ListItem>
					)}
				</List>
			</Drawer>
			<Dialog onClose={onCloseDialog} open={dialog} {...{TransitionComponent}}>
				<DialogTitle>Save Mortgage Calculator</DialogTitle>
				<DialogContent sx={{pt: `16px !important`}}>
					<TextField
						label="Mortgage Calculator Name"
						fullWidth
						value={name}
						{...{onChange}}
						error={!name.length}
						helperText={!name.length ? "You must provide a name!" : ""}
					/>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={onCloseDialog}>
						Cancel
					</Button>
					<Button onClick={save} disabled={!name.length}>Save</Button>
				</DialogActions>
			</Dialog>
			{/*<Dialog open={error} {...{TransitionComponent}}>*/}
			{/*	<DialogTitle>Authentication Failed</DialogTitle>*/}
			{/*	<DialogContent sx={{pt: `16px !important`}}>*/}
			{/*		<DialogContentText>*/}
			{/*			Your session has expired. Click OK to go back to the login page of ChoiceU.*/}
			{/*		</DialogContentText>*/}
			{/*	</DialogContent>*/}
			{/*	<DialogActions>*/}
			{/*		<Button onClick={redirect}>OK</Button>*/}
			{/*	</DialogActions>*/}
			{/*</Dialog>*/}
			<Snackbar open={notification} autoHideDuration={2000} onClose={closeNotification} anchorOrigin={{vertical: "bottom", horizontal: "center"}}>
				<Alert onClose={closeNotification} elevation={6} variant="filled" severity={email.severity} sx={{width: "100%"}}>
					{email.message}
				</Alert>
			</Snackbar>
			<Box sx={{overflow: "hidden", height: 0, width: 0}}>
				<Box id="print" sx={{width: "1600px", bgcolor: "background.paper"}}>
					<Box sx={{display: "flex", bgcolor: "background.paper", justifyContent: "center"}}>
						<img style={{width: 156, height: 46}} src="./img/logo.png" alt="Company Logo" />
						<img src="./img/your-key-to-profit.png" alt="Your Key To Profit Logo" />
					</Box>
					<Box id="printFill" sx={{width: "100%"}} />
					<Box sx={{display: "flex", bgcolor: "background.paper", justifyContent: "center", pb: 1}}>
						<Typography>You acknowledge that we have not provided you with any financial or other advice. We advise you to consult with your own financial or other advisor.</Typography>
					</Box>
				</Box>
			</Box>
		</>
	);
};
